import React from 'react';
import { CustomCheckBox, CustomCheckBoxSm }
    from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import './CheckBox.scss'

class CheckBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customDataObjects: {}
        }
    }

    handleCheckBox = ({ name, checked }) => {
        const { customDataObjects } = this.state;
        this.setState({ [name]: checked, [`${name}_checked`]: checked });
        this.setState({
            customDataObjects: { ...customDataObjects, [name]: checked ? 1 : 0 }
        });
        StoreHelper.checkAndUpdateDataObj({
            updateDataObjects: this.props.updateDataObjects,
            mainObj: this.props.mainObj, subObjName: this.props.subObjName,
            name: name, value: checked ? 1 : 0
        });
    }

    onCheckBoxChange = event => {
        const { checked, name } = event.target;
        this.handleCheckBox({ name, checked });
    };

    componentDidMount() {
        if (this.props.item && this.props.item.name && this.props.item.checked) {
            setTimeout(() => this.handleCheckBox({ name: this.props.item.name, checked: true }), 100);
        }
    }

    render() {
        const { item } = this.props;
        if (this.props.isShort)
            return (
                <div className="CheckBox">
                    <CustomCheckBoxSm fMsgId={item.intl} name={item.name} value={this.state.customDataObjects[item.name]}
                        onChange={this.onCheckBoxChange} checked={this.state[`${item.name}_checked`]} />
                </div>)

        return (
            <div className="CheckBox">
                <CustomCheckBox fMsgId={item.intl} name={item.name} value={this.state.customDataObjects[item.name]}
                    onChange={this.onCheckBoxChange} checked={this.state[`${item.name}_checked`]} />
            </div>)
    }
}


export default CheckBox;